import { parseResponse } from 'utils/parseResponse';
import { endpoints } from '../endpoints';
import { getHeader } from './generalApi';

export async function getTenants() {
  return fetch(`${endpoints.tenant}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getTenant(tenantId) {
  return fetch(`${endpoints.tenant}/${tenantId}`, {
    ...(await getHeader('GET', tenantId))
  }).then(parseResponse);
}
